import {
  useDismissMessageMutation,
  usePublishMessageMutation,
  useUnpublishMessageMutation,
} from "../../../api/apiSlice";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import "global.css";
import { IMessage, messageDeExer } from "api/apiTypes";
interface SuperChatProps {
  message: IMessage;
}

export const SuperChats = (props: SuperChatProps) => {
  const { message } = props;
  const [dismissMessage] = useDismissMessageMutation();
  const [publishMessage, { isLoading: isPublishLoading }] =
    usePublishMessageMutation();
  const [unpublishMessage, { isLoading: isUnpublishLoading }] =
    useUnpublishMessageMutation();

  const onDismissClicked = async (messageId: string) => {
    dismissMessage(messageId);
  };

  const onPublishClicked = async (messageId: string) => {
    if (!isPublishLoading) {
      publishMessage(messageId);
    }
  };

  const onUnpublishClicked = async (messageId: string) => {
    if (!isUnpublishLoading) {
      unpublishMessage(messageId);
    }
  };
  return (
    <Card
      bg="light"
      className="mb-3"
      border={message.state === "Published" ? "warning" : ""}
    >
      <Card.Header>
        <Image
          alt="Author avatar"
          roundedCircle
          className="me-2"
          src={message.authorUrl}
        />
        <span className="nerdle-author-name align-middle">
          {message.author}
        </span>
        {message.badgeUrl && (
          <Image roundedCircle className="ms-1" src={message.badgeUrl} />
        )}
      </Card.Header>
      <Card.Body>
        <Card.Title>
          {message.amountString}&nbsp;{message.currency}
        </Card.Title>
        <Card.Subtitle>{message.currency_name}</Card.Subtitle>
        <Card.Text>{messageDeExer(message.messageEx)}</Card.Text>
        <Card.Text className="text-secondary mb-0">{message.streamName} Stream</Card.Text>
        <Card.Text className="text-secondary">{message.datetime}</Card.Text>
        {message.state !== "Published" ? (
          <>
            {message.bgColor !== 4280191205 && (
              <Button
                variant="warning"
                disabled={isPublishLoading}
                onClick={() => onPublishClicked(message.messageId)}
                className="me-2"
              >
                Publish
              </Button>
            )}
            <Button
              variant="primary"
              disabled={isPublishLoading}
              onClick={() => onDismissClicked(message.messageId)}
            >
              Dismiss
            </Button>
          </>
        ) : (
          <Button
            variant="danger"
            disabled={isUnpublishLoading}
            onClick={() => onUnpublishClicked(message.messageId)}
          >
            Unpublish
          </Button>
        )}
      </Card.Body>
    </Card>
  );
};
